import Link from "next/link"

const resourcesData = [
  { href: "/foundation/house", text: "Historic House" },
  { href: "/resources", text: "Conducting Research" },
  { href: "/resources/rights-reproduction", text: "Rights & Reproductions" },
  { href: "/mailing-list", text: "Join our mailing list" },
]

const aboutData = [
  { href: "/artist", text: "Artist" },
  { href: "/foundation", text: "Foundation" },
  { href: "/features", text: "Features" },
  { href: "/resources", text: "Resources" },
  { href: "/works", text: "Works" },
]

const InstagramIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C9.5556 3 9.2496 3.0102 8.2896 3.054C7.3314 3.0978 6.6768 3.2502 6.1044 3.4728C5.5044 3.6984 4.9602 4.0524 4.5102 4.5108C4.05253 4.96028 3.69831 5.5041 3.4722 6.1044C3.2508 6.6768 3.0978 7.332 3.054 8.2902C3.0108 9.2496 3 9.555 3 12C3 14.445 3.0102 14.7504 3.054 15.7104C3.0978 16.6686 3.2502 17.3232 3.4728 17.8956C3.6984 18.4956 4.0524 19.0398 4.5108 19.4898C4.96029 19.9475 5.50411 20.3017 6.1044 20.5278C6.6768 20.7498 7.3314 20.9022 8.2896 20.946C9.2496 20.9898 9.5556 21 12 21C14.4444 21 14.7504 20.9898 15.7104 20.946C16.6686 20.9022 17.3232 20.7498 17.8956 20.5272C18.4956 20.3016 19.0398 19.9476 19.4898 19.4892C19.9475 19.0397 20.3017 18.4959 20.5278 17.8956C20.7498 17.3232 20.9022 16.6686 20.946 15.7104C20.9898 14.7504 21 14.4444 21 12C21 9.5556 20.9898 9.2496 20.946 8.2896C20.9022 7.3314 20.7498 6.6768 20.5272 6.1044C20.3012 5.50384 19.947 4.95979 19.4892 4.5102C19.0397 4.05253 18.4959 3.69831 17.8956 3.4722C17.3232 3.2508 16.668 3.0978 15.7098 3.054C14.7504 3.0108 14.445 3 12 3ZM12 4.6218C14.403 4.6218 14.688 4.6308 15.6372 4.674C16.5144 4.7142 16.9908 4.86 17.3082 4.9842C17.7282 5.1468 18.0282 5.3424 18.3432 5.6568C18.6582 5.9718 18.8532 6.2718 19.0158 6.6918C19.1394 7.0092 19.2858 7.4856 19.326 8.3628C19.3692 9.312 19.3782 9.597 19.3782 12C19.3782 14.403 19.3692 14.688 19.326 15.6372C19.2858 16.5144 19.14 16.9908 19.0158 17.3082C18.8718 17.6991 18.6419 18.0528 18.3432 18.3432C18.0528 18.642 17.6992 18.8718 17.3082 19.0158C16.9908 19.1394 16.5144 19.2858 15.6372 19.326C14.688 19.3692 14.4036 19.3782 12 19.3782C9.5964 19.3782 9.312 19.3692 8.3628 19.326C7.4856 19.2858 7.0092 19.14 6.6918 19.0158C6.30087 18.8718 5.9472 18.6419 5.6568 18.3432C5.35811 18.0528 5.12828 17.6991 4.9842 17.3082C4.8606 16.9908 4.7142 16.5144 4.674 15.6372C4.6308 14.688 4.6218 14.403 4.6218 12C4.6218 9.597 4.6308 9.312 4.674 8.3628C4.7142 7.4856 4.86 7.0092 4.9842 6.6918C5.1468 6.2718 5.3424 5.9718 5.6568 5.6568C5.94716 5.35803 6.30085 5.12819 6.6918 4.9842C7.0092 4.8606 7.4856 4.7142 8.3628 4.674C9.312 4.6308 9.597 4.6218 12 4.6218Z"
        fill="#E6E3E3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.0028C11.6057 15.0028 11.2152 14.9251 10.8508 14.7742C10.4865 14.6233 10.1554 14.4021 9.87658 14.1232C9.59773 13.8444 9.37653 13.5133 9.22561 13.149C9.0747 12.7846 8.99702 12.3941 8.99702 11.9998C8.99702 11.6054 9.0747 11.2149 9.22561 10.8506C9.37653 10.4862 9.59773 10.1552 9.87658 9.87635C10.1554 9.59749 10.4865 9.37629 10.8508 9.22538C11.2152 9.07446 11.6057 8.99679 12 8.99679C12.7965 8.99679 13.5603 9.31318 14.1235 9.87635C14.6866 10.4395 15.003 11.2033 15.003 11.9998C15.003 12.7962 14.6866 13.5601 14.1235 14.1232C13.5603 14.6864 12.7965 15.0028 12 15.0028ZM12 7.37379C10.7731 7.37379 9.59649 7.86117 8.72895 8.72871C7.8614 9.59626 7.37402 10.7729 7.37402 11.9998C7.37402 13.2267 7.8614 14.4033 8.72895 15.2709C9.59649 16.1384 10.7731 16.6258 12 16.6258C13.2269 16.6258 14.4036 16.1384 15.2711 15.2709C16.1386 14.4033 16.626 13.2267 16.626 11.9998C16.626 10.7729 16.1386 9.59626 15.2711 8.72871C14.4036 7.86117 13.2269 7.37379 12 7.37379ZM17.9718 7.28979C17.9718 7.5798 17.8566 7.85794 17.6515 8.06301C17.4465 8.26808 17.1683 8.38329 16.8783 8.38329C16.5883 8.38329 16.3102 8.26808 16.1051 8.06301C15.9 7.85794 15.7848 7.5798 15.7848 7.28979C15.7848 6.99977 15.9 6.72164 16.1051 6.51657C16.3102 6.3115 16.5883 6.19629 16.8783 6.19629C17.1683 6.19629 17.4465 6.3115 17.6515 6.51657C17.8566 6.72164 17.9718 6.99977 17.9718 7.28979Z"
        fill="#E6E3E3"
      />
    </svg>
  )
}

const Footer = () => {
  return (
    <footer tw="bg-rpd-gray-8 text-white py-10 font-sans text-sm relative bottom-0 w-full mt-24 tablet:(mt-48)">
      <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
        <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6 gap-y-0)">
          <div tw="col-span-4 tablet-lg:(col-span-3)">
            <div tw="space-y-2">
              <h2 tw="font-bold">
                <Link href={`/`}>
                  <>The Richard Pousette-Dart Foundation</>
                </Link>
              </h2>
              <p>
                <Link href={`mailto:info@pousette-dartfoundation.org`}>
                  <>info@pousette-dartfoundation.org</>
                </Link>
              </p>
            </div>
          </div>
          <div tw="col-span-4 tablet-lg:(col-span-3)">
            <ul tw="space-y-2">
              {resourcesData.map((item, i) => {
                return (
                  <li key={i} tw="">
                    <Link href={`${item.href}`} passHref>
                      <>{item.text}</>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
          <div tw="col-span-4 tablet-lg:(col-span-3)">
            <ul tw="space-y-2">
              {aboutData.map((item, i) => {
                return (
                  <li key={i} tw="">
                    <Link href={`${item.href}`} passHref>
                      <>{item.text}</>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
          <div tw="col-span-4 tablet-lg:(col-span-3)">
            <div tw="space-y-4">
              <Link
                href="https://www.instagram.com/pousettedartfoundation/"
                passHref
                tw="px-2.5 py-3 rounded-sm bg-rpd-green flex space-x-2"
              >
                <>
                  <span>Follow @pousettedartfoundation</span> <InstagramIcon />
                </>
              </Link>
              <p>
                <>© {new Date().getFullYear()} The Richard Pousette-Dart Foundation</>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
